import {ParameterType} from 'insights/parameters/ParameterTypes';

export type EmbeddableParameterType = ParameterType.BIOENTITY_LINK;

export const EMBEDDABLE_TYPE_TO_LABEL: {[key in EmbeddableParameterType]: string} = {
  [ParameterType.BIOENTITY_LINK]: 'Entity ID',
};

// Displayed next to the checkbox to use the embedding item as the template value.
export const EMBEDDABLE_TYPE_TO_INSTRUCTION_LABEL: {[key in EmbeddableParameterType]: string} = {
  [ParameterType.BIOENTITY_LINK]: 'Set parameter to entity being viewed',
};
